module.exports = __webpack_public_path__ + "img/House-Dog.b8a430d8.png";